import { render } from "./StoreInfoEdirt.vue?vue&type=template&id=72892b70&scoped=true"
import script from "./StoreInfoEdirt.vue?vue&type=script&lang=js"
export * from "./StoreInfoEdirt.vue?vue&type=script&lang=js"

import "./StoreInfoEdirt.vue?vue&type=style&index=0&id=72892b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72892b70"]])

export default __exports__